module.exports = __webpack_public_path__ + "img/TZS09498.33c05df3.jpeg";